import { render } from "./blog.vue?vue&type=template&id=4fb612a5"
import script from "./blog.vue?vue&type=script&lang=js"
export * from "./blog.vue?vue&type=script&lang=js"

import "./blog.vue?vue&type=style&index=0&id=4fb612a5&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__